import SectionHeading from '@/components/feature/SectionHeading';
import { overviewPoints } from '@/mocks/drama';

export default function Intro() {
  return (
    <section id="intro" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-16">
          <div>
            <SectionHeading
              eyebrow="About this page"
              title="本站为你梳理《继母的诱惑》的完整故事"
              desc="很多人第一次接触这个题材时，会被碎片化的片段和不同的版本说法绕晕。本页把短剧与小说的主线、人物与细节集中整理在同一个页面，帮你先建立整体认知，再决定从哪一段开始深入。"
            />
            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-lightbulb-line text-xl"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    阅读建议
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    时间有限的读者可直接看「剧情脉络」快速掌握转向；想追细节的读者建议按「人物关系 → 未删减细节 → 核心主题」的顺序阅读，理解会更连贯。
                    以下内容为剧情层面的解析与整理，具体以你观看的版本为准。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {overviewPoints.map((point) => (
              <div
                key={point.title}
                className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${point.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {point.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}